module.exports = __webpack_public_path__ + "static/media/Doklad_vyznagrajdeniya_22.05.2018.5e35269a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2018/Doklad_vyznagrajdeniya_22.05.2018.pdf
// module id = 138
// module chunks = 0